export default __webpack_public_path__ + "static/Flo-73bb9921e5732d8bee86e9e29fdcc5c8.png";